module.exports = __webpack_public_path__ + "img/icon-transactions.b509e93d.svg";